const PageGeneric = {

    props: ["pageId"],

    data () {
        var objData = touchKit.PageManager.getPage(this.pageId) || { data: { html: ""}}
        return {
            html: objData.data.html
        }
    },

    template: `
        <div class="page" :id="setPageId">
            <div :class="setWrapperClass" v-html="html">
            </div>
        </div>
    `,


    computed: {
        setPageId () {
            return this.pageId + "__page"
        },
        setWrapperClass () {
            return this.pageId + "__page_wrapper"
        }
    }
}